import React from 'react';
import { User, Membership } from '../types';
import { books } from '../data/mockData';
import { useLanguage } from '../i18n/LanguageContext';

interface BooksPageProps {
  user: User | null;
}

const BooksPage: React.FC<BooksPageProps> = ({ user }) => {
  const { t } = useLanguage();
  return (
    <div className="container mx-auto max-w-3xl">
      <h1 className="text-4xl font-bold mb-4 text-center">{t('booksPage.title')}</h1>
      <p className="text-center text-stone-600 mb-8">{t('booksPage.subtitle')}</p>
      
      <div className="space-y-6">
        {books.map(book => {
          const isLocked = book.is_premium_notes && user?.membership !== Membership.Premium;
          return (
            <div key={book.title} className="bg-white/60 p-8 rounded-3xl shadow-lg border border-white/50">
              <h2 className="text-2xl font-bold">{book.title}</h2>
              <p className="text-stone-500 italic mb-3">{t('booksPage.by')} {book.author}</p>
              <p className="text-stone-700 mb-4">{book.summary}</p>
              <button 
                disabled={isLocked}
                className="font-semibold text-accent hover:underline disabled:text-stone-400 disabled:no-underline disabled:cursor-not-allowed"
              >
                {isLocked ? t('booksPage.upgradeToView') : t('booksPage.viewNotes')}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BooksPage;